export default __webpack_public_path__ + "static/headshot-f35cb3c09cb05c6cc15fc3c483f19868.jpeg";